import React, { useState } from 'react';
import { Modal, Box, TextField, Button, Typography, CircularProgress } from '@mui/material';
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useNavigate } from 'react-router-dom';
import { getCompanyName } from '../utils/utility';
import Loader from './Loader';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});




const containerStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  minWidth: 300,
  maxWidth: 400,
  borderRadius: 4
}

const inputStyles = {
  '& .MuiFormHelperText-root': {
    marginLeft: '0px',
    marginTop: '10px'
  }
};








const CreatePackageModal = ({ open, onClose, userData }) => {
  const [packageName, setPackageName] = useState('');
  const [error, setError] = useState('');
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [apiError, setApiError] = useState('');
  const [showLoader, setShowLoader] = useState(false);

  const navigate = useNavigate();
  const env = process.env.REACT_APP_STAGE;
  const allowedScopeForDev = 'hd-test'


  const userCompany = getCompanyName(userData?.user?.email)
  const userName = userData?.profileData?.userName?.toLowerCase();
  const errorMessage = env === 'development' ? `Component should only have @${allowedScopeForDev} scope and valid name in small letters.`   : `${userName && userCompany ? `Component name should have a valid scope either @${userName}/packageName or @${userCompany}/packageName and valid name in small letters.`
    : userName && !userCompany ? `Component name should have a valid scope @${userName}/packageName`
      : !userName && userCompany ? `Component name should have a valid scope @${userCompany}/packageName` : null}` ;
  const handleChange = (event) => {
    setPackageName(event.target.value);
    setError('');
  };

  const handleSubmit = () => {
    if (showLoader) return; // prevent double submission if request already in-flight
    // Validation for package name with valid scope
    const scopeRegex = /^@(?:[a-z0-9](?:[a-z0-9_-]*[a-z0-9])?)\/[a-z0-9._-]+$/;

    if (!scopeRegex.test(packageName)) {
      setError(errorMessage);
      return;
    }

    // Extracting the username and company from the packageName
    const scope = packageName.split('/')[0]
    const updatedScope = scope.substring(1).split('@')[0];

    // Check if either userName or userCompany is present if production and valid scope for development
    if ((env === 'production' &&  updatedScope !== userName && updatedScope !== userCompany) || (env === 'development' && updatedScope !== allowedScopeForDev)) {
      setError(errorMessage);
      return;
    } else {
      setError('');
      setShowLoader(true);
      const url = `/nodeapi/portal/create-package`

      const payload = {
        componentName: packageName
      };
      const headers = {
        "Content-Type": "application/json",
      };

      const requestOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(payload),
        credentials: "include",
      };

      fetch(url, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result && result.success && result.success === 1) {
            setSnackBarOpen(true);
            setShowLoader(false);
            setTimeout(() => {
              navigate(`/package?componentName=${packageName}&templateName=${packageName}`, {
                state: {
                  hd_id: userData?.hd_id,
                  userID: userData?.user?.email,
                  componentName: packageName,
                  templateName: packageName

                }
              });
            }, 1000)

          } else {
            if(result.err && result.errMsg){
              setError(result.errMsg)          
            }
            setApiError(true);
            setSnackBarOpen(true);
            setShowLoader(false);
            setTimeout(() => {
              onClose();
            }, 1000);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setApiError(true);
          setSnackBarOpen(true);
          setShowLoader(false);
          setTimeout(() => {
            onClose();
          }, 1000);

        });

    }

    // Submit logic here
    // For example, you can call an API to create the package
  };





  return (
    <>
      <Modal open={open} onClose={onClose} >
        <Box
          sx={containerStyles}
        >
          <Typography variant="h6" gutterBottom>
            Create Package
          </Typography>
          <TextField
            label="Package Name"
            variant="outlined"
            fullWidth
            value={packageName}
            onChange={handleChange}
            sx={inputStyles}
            error={!!error}
            helperText={<Typography variant='caption'>
              {error || (
                errorMessage
              )}
            </Typography>
            }
          />
          {
            showLoader ? <Loader color='primary' /> : <Button variant="contained" color="primary"
              size='small'
              onClick={handleSubmit} sx={{ mt: 2 }}>
              Submit
            </Button>
          }
        </Box>
      </Modal>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackBarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {
          apiError ?
            <Alert
              onClose={() => setSnackBarOpen(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
             {
                error || `Package Creation Failed! Please try again in sometime.`
             }
            </Alert>
            : <Alert
              onClose={() => setSnackBarOpen(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              Package Created SuccessFully!
            </Alert>
        }
      </Snackbar>
    </>
  );
};

export default CreatePackageModal;
